export const anggaranPengeluaranFormData = (
  dropdownUnitUsaha,
  dropdownAkuns,
  dropdownTahun
) => {
  return [
    {
      id: "id_unit_usaha",
      label: "Pilih Unit Usaha",
      fields: [
        {
          type: "option",
          options: dropdownUnitUsaha,
        },
      ],
    },
    {
      id: "id_sistem_akun",
      label: "Pilih Akun",
      fields: [
        {
          type: "option",
          options: dropdownAkuns,
        },
      ],
    },
    {
      id: "nama_anggaran_pengeluaran",
      label: "Nama anggaran pengeluaran",
      fields: [
        {
          type: "input",
          placeholder: "Masukan nama anggaran pengeluaran",
        },
      ],
    },
    {
      id: "jumlah_anggaran_pengeluaran",
      label: "Jumlah anggaran pengeluaran",
      fields: [
        {
          type: "input",
          placeholder: "Masukan jumlah anggaran pengeluaran",
        },
      ],
    },
    {
      id: "tahun_anggaran_pengeluaran",
      label: "Tahun Anggaran Pengeluaran",
      fields: [
        {
          type: "option",
          options: dropdownTahun,
        },
      ],
    },
  ];
};
